var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"fullscreenBTN mb-1",attrs:{"outlined":"","color":"grey","elevation":"0"},on:{"click":_vm.fullscreen}},[_vm._v(" "+_vm._s(_vm.$t("studio.toggleFullscreen"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }